import { render, staticRenderFns } from "./FormVertical.vue?vue&type=template&id=58edb9fe"
import script from "./FormVertical.vue?vue&type=script&lang=js"
export * from "./FormVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports